export default __webpack_public_path__ + "img/dygTYVUG.8ddfa4cb.svg";